import React, { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { BlankLayoutWrapper } from './BlankLayoutStyled'
import { useRecoilState } from 'recoil'
import { currentPageState } from '../../recoil/commonState'
import { PAGES } from '../../constant'
import LandingBody from '../../components/LandingBody'

const BlankLayout = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [currentPage, setCurrentPage] = useRecoilState(currentPageState)

  useEffect(() => {
    const segment = location.pathname.split(PAGES.HOME.PATH).filter(item => item !== '')
    if (segment.length === 0) {
      setCurrentPage(PAGES.HOME.PATH)
    } else {
      setCurrentPage(`/${segment[0]}`)
    }
  }, [location.pathname])
  
  return (
    <BlankLayoutWrapper>
      <LandingBody>
        <Outlet />
      </LandingBody>
    </BlankLayoutWrapper>
  )
}

export default BlankLayout
